import { camelCaseToSentenceCase, formatFullName, deduplicateArrayOfObjectsByID, getUserPath } from '@caresend/utils';
import update from 'immutability-helper';
import '@caresend/types';
import 'firebase/auth';
import '../../../../database/firebaseConfig/cloudFunctions.js';
import '../../../../database/firebaseConfig/init.js';
import { dbSet } from '../../../../database/firebaseConfig/methods.js';
import '@sentry/vue';
import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/sharp-regular-svg-icons';
import 'buefy';
import '../../../ui/Icon.vue.js';
import '../../../../functions/configuration/icons.js';
import '../../../../database/algoliaConfig/indices.js';
import 'mobile-device-detect';
import '../../../../functions/tracking/index.js';
import '../../../../router/helpers/initRouter.js';
import { getStore } from '../../../../store/helpers/initStore.js';
import '@firebase/auth';
import 'browser-image-compression';
import 'firebase/storage';
import 'js-sha256';
import { PrimaryContact } from './model.js';

const authUserSchedulingOption = () => {
    const store = getStore();
    const { user } = store.state.auth;
    if (!user)
        return;
    return {
        id: user.id,
        label: formatFullName(user),
    };
};
const getSchedulingUserOptions = () => {
    var _a, _b, _c, _d, _e, _f, _g;
    const store = getStore();
    const options = [];
    const authUserOption = authUserSchedulingOption();
    if (authUserOption) {
        options.push(authUserOption);
    }
    options.push({
        id: PrimaryContact.SOMEBODY_ELSE,
        label: camelCaseToSentenceCase(PrimaryContact.SOMEBODY_ELSE),
    });
    const patients = Object.values((_a = store.state.schedulingFlow.patients) !== null && _a !== void 0 ? _a : {}).map((patient) => ({
        label: formatFullName(patient),
        id: patient.id,
    }));
    const orderID = (_c = (_b = store.state.schedulingFlow.draftWaypoint) === null || _b === void 0 ? void 0 : _b.draftOrderID) !== null && _c !== void 0 ? _c : (_e = Object.values((_d = store.state.schedulingFlow.procedures) !== null && _d !== void 0 ? _d : {})[0]) === null || _e === void 0 ? void 0 : _e.orderID;
    const schedulingUserID = (_g = (_f = store.state.orders.orders) === null || _f === void 0 ? void 0 : _f[orderID !== null && orderID !== void 0 ? orderID : '']) === null || _g === void 0 ? void 0 : _g.schedulingUserID;
    const schedulingUser = store.getters['users/getStaffUserByID'](schedulingUserID !== null && schedulingUserID !== void 0 ? schedulingUserID : '');
    if (schedulingUserID && schedulingUser) {
        options.push({
            id: schedulingUserID,
            label: formatFullName(schedulingUser),
        });
    }
    const allUsers = deduplicateArrayOfObjectsByID([...options, ...patients]);
    return allUsers;
};
/**
 * If there is only one patient, that patient is selected.
 * If there is more than one patient, the scheduling user is selected.
 * If there is more than one patient and the scheduling user is not a patient,
 * the first patient is selected.
 */
const getPointOfContact = (options) => {
    var _a, _b;
    const store = getStore();
    const { patients } = store.state.schedulingFlow;
    const patientList = Object.values(patients !== null && patients !== void 0 ? patients : {});
    if (patientList.length > 1) {
        const schedulingUserID = store.getters['schedulingFlow/getSchedulingUserID'];
        const schedulingUser = patients[schedulingUserID !== null && schedulingUserID !== void 0 ? schedulingUserID : ''];
        return (_a = options.find((option) => { var _a, _b; return option.id === ((_a = schedulingUser === null || schedulingUser === void 0 ? void 0 : schedulingUser.id) !== null && _a !== void 0 ? _a : (_b = patientList[0]) === null || _b === void 0 ? void 0 : _b.id); })) !== null && _a !== void 0 ? _a : null;
    }
    return (_b = options.find((option) => { var _a; return option.id === ((_a = patientList[0]) === null || _a === void 0 ? void 0 : _a.id); })) !== null && _b !== void 0 ? _b : null;
};
const setUserPhone = async (userID, phone) => {
    await dbSet(getUserPath(userID, 'info/phone'), phone);
    const store = getStore();
    /**
     * Staff user and patient are not mutually exclusive because the scheduling
     * user is saved as a staff user, even if the scheduling user is a patient
     *
     * we will need to address this future
     *
     * until then I will update the data in both places
     */
    const currentStaffUser = store.state.users.staffUsers[userID !== null && userID !== void 0 ? userID : ''];
    if (currentStaffUser) {
        const newStaffUser = update(currentStaffUser, {
            info: {
                phone: { $set: phone },
            },
        });
        store.commit('users/SET_STAFF_USER', newStaffUser);
    }
    const currentPatient = store.state.schedulingFlow.patients[userID !== null && userID !== void 0 ? userID : ''];
    if (currentPatient) {
        const newPatient = update(currentPatient, {
            info: {
                phone: { $set: phone },
            },
        });
        store.commit('schedulingFlow/SET_PATIENT', newPatient);
    }
};

export { authUserSchedulingOption, getPointOfContact, getSchedulingUserOptions, setUserPhone };
